<template>
  <div>
    <b-card class="md-3" style="min-height: 410px">
      <!-- Titulo de la seccion-->
      <b-row>
        <b-col class="align-left">
          <p>Editar sensor seleccionado</p>
        </b-col>
      </b-row>

      <!-- Formulario de adicion de nodos -->
      <div id="formulario-nodos" style="width: 100%">
        <div v-if="!submitted">
          <!-- INIT FORMULARIO DE ADICION -->
          <b-form @submit="updateSensor" @reset="exitForm">
            <div class="groupBox">
              <b-row>
                <b-col>
                  <p class="titulo1 text-center">Parámetros del sensor</p>
                  <div class="groupBox">
                    <!-- Fila 1 -->
                    <b-row>
                      <b-col>
                        <b-form-group
                          label-size="sm"
                          label="Descripción del sensor *"
                          label-for="description"
                        >
                          <b-form-input
                            id="description"
                            name="description"
                            size="sm"
                            placeholder="..."
                            v-model="currentSensor.description"
                            :value="currentSensor.description"
                            :disabled="disabledInput"
                            required
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <!-- Fila 4 -->
                    <b-row>
                      <b-col>
                        <b-form-group label-size="sm">
                          <label for="sensor_number">
                            Número de sensor
                            <span style="color: red; font-size: 0.78rem"
                              >(valor ignorado si se modifica también el nodo
                              asociado)</span
                            >
                          </label>
                          <b-form-input
                            type="number"
                            id="sensor_number"
                            name="sensor_number"
                            size="sm"
                            placeholder="..."
                            v-model="currentSensor.sensor_number"
                            required
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <!-- Fila 5 -->
                    <b-row>
                      <b-col>
                        <b-form-group
                          label-size="sm"
                          label="Asociar a un nodo"
                          label-for="devices"
                        >
                          <b-form-select
                            size="sm"
                            id="devices"
                            name="devices"
                            v-model="selectedDeviceAlias"
                            style="cursor: pointer"
                            :disabled="disabledInput"
                          >
                            <b-form-select-option value="null"
                              >Ningun nodo</b-form-select-option
                            >
                            <b-form-select-option
                              v-for="(alias, index) in deviceAliasList"
                              v-bind:key="index"
                              v-bind:value="alias"
                            >
                              {{ alias }}
                            </b-form-select-option>
                          </b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <!-- Fila 1 -->
                    <b-row>
                      <b-col>
                        <b-form-group
                          label-size="sm"
                          label="Tipologia sensor"
                          label-for="type"
                        >
                          <b-form-select
                            size="sm"
                            id="tipologia"
                            name="tipologia"
                            v-model="selectedTypeAlias"
                            style="cursor: pointer"
                            @change="fillType"
                          >
                            <b-form-select-option value="null"
                              >Tipo no seleccionado</b-form-select-option
                            >
                            <b-form-select-option
                              v-for="type in typeAliasList"
                              v-bind:key="type.alias"
                              v-bind:value="type"
                            >
                              {{ type }}
                            </b-form-select-option>
                          </b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <!-- Fila 2 -->
                    <b-row>
                      <b-col>
                        <div
                          class="innergroupBox"
                          style="
                            padding: 15px 5px 5px 5px !important;
                            margin-bottom: 10px;
                            cursor: pointer;
                          "
                        >
                          <b-row>
                            <b-form-group
                              class="form-check form-switch"
                              style="margin-left: 50px; cursor: pointer"
                              v-if="selectedType && selectedType.shmCapable"
                            >
                              <input
                                class="form-check-input"
                                v-model="currentSensor.isShm"
                                :checked="currentSensor.isShm"
                                type="checkbox"
                                id="switchSHM"
                                style="cursor: pointer"
                              />
                              <label class="form-check-label" for="switchSHM"
                                >Procesar medidas usando SHM</label
                              >
                            </b-form-group>
                          </b-row>
                        </div>
                      </b-col>
                    </b-row>

                    <!-- Fila 2 -->
                    <b-row>
                      <b-col>
                        <div class="innergroupBox" style="margin-bottom: 15px">
                          <b-row>
                            <b-col>
                              <center>
                                <img
                                  v-if="selectedType && selectedType != 'null'"
                                  style="height: 115px"
                                  :src="getImgUrl(selectedType.image)"
                                />
                                <img
                                  v-else
                                  style="height: 115px"
                                  :src="getImgUrl('default.svg')"
                                />
                              </center>
                            </b-col>
                            <b-col>
                              <p
                                v-if="selectedType && selectedType != 'null'"
                                v-html="selectedType.description"
                              ></p>
                              <p v-else>
                                Debe seleccionar un tipo para mostrar su
                                descripción
                              </p>
                            </b-col>
                          </b-row>
                        </div>
                      </b-col>
                    </b-row>

                    <!-- Fila 3 -->
                    <b-row>
                      <b-col>
                        <b-form-group
                          label-for="updatesensor"
                          v-if="isUserAdmin()"
                        >
                          <b-button
                            block
                            type="submit"
                            name="updatesensor"
                            id="updatesensor"
                            variant="success"
                            size="sm"
                          >
                            <i class="fas fa-edit"></i>
                            <span
                              class="text-uppercase"
                              style="
                                font-size: 12px;
                                font-weight: bold;
                                margin-left: 5px;
                              "
                              >Guardar cambios</span
                            >
                          </b-button>
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group label-for="cleanform">
                          <b-button
                            block
                            type="reset"
                            name="cleanform"
                            id="cleanform"
                            variant="danger"
                            size="sm"
                          >
                            <i class="fas fa-arrow-left"></i>
                            <span
                              class="text-uppercase"
                              style="
                                font-size: 12px;
                                font-weight: bold;
                                margin-left: 5px;
                              "
                              >Salir de la edicion</span
                            >
                          </b-button>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <!-- Fila 5 -->
                    <b-row>
                      <b-col>
                        <small>* El campo debe ser rellenado</small><br />
                        <small
                          >** Utilize el valor 0 para no especificar el
                          intervalo</small
                        >
                      </b-col>
                    </b-row>
                  </div>
                </b-col>

                <!--BLoque derechas -->
                <b-col>
                  <p class="titulo1 text-center">
                    Personalizar la denominación de las medidas
                  </p>
                  <div class="groupBox">
                    <b-row
                      v-for="(data, index) in dataFields"
                      :key="index"
                      class="innergroupBoxAlt"
                    >
                      <b-col>
                        <b-form-group
                          :label="
                            'Denominación de la medida \'' + data.label + '\''
                          "
                          label-size="sm"
                          :label-for="'denomination' + index"
                        >
                          <b-form-input
                            :id="'denomination' + index"
                            :name="'customColumnNames' + index"
                            size="sm"
                            placeholder="..."
                            v-model="currentSensor.customColumnNames[index]"
                            :value="currentSensor.customColumnNames[index]"
                          />

                          <div style="margin-left: 20px">
                            <input
                              class="form-check-input"
                              v-model="currentSensor.customColumnHide[index]"
                              :input-value="
                                currentSensor.customColumnHide[index]
                              "
                              type="checkbox"
                              :id="'hideColumn' + index"
                              style="cursor: pointer"
                            />
                            <label
                              class="form-check-label"
                              for="'hideColumn' + index"
                              style="font-size: 0.8rem"
                            >
                              Ocultar columna en tablas
                            </label>
                          </div>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                  <div class="groupBox mt-2" v-if="selectedTypeAlias == 'Pluviometro WS2080' || selectedTypeAlias == 'Contador Hidrojet 80H-20V'">

                    <b-row class="innergroupBoxAlt">
                      <b-col>
                        <b-form-group
                          label="Máximo incremento (mm)"
                          label-size="sm"
                          label-for="max-increment"
                          v-if="selectedTypeAlias == 'Pluviometro WS2080'"
                        >
                          <b-form-input
                            id="max-increment"
                            size="sm"
                            placeholder="..."
                            v-model="currentSensor.thresholds.maxIncrement"
                            :value="currentSensor.thresholds.maxIncrement"
                          />
                        </b-form-group>
                        <b-form-group
                          label="Máxima acumulación por chubasco (mm)"
                          label-size="sm"
                          label-for="max-shower-accumulation"
                          v-if="selectedTypeAlias == 'Pluviometro WS2080'"
                        >
                          <b-form-input
                            id="max-shower-accumulation"
                            size="sm"
                            placeholder="..."
                            v-model="currentSensor.thresholds.maxShowerAccumulation"
                            :value="currentSensor.thresholds.maxShowerAccumulation"
                          />
                          <div>
                            <p
                              style="font-size: 0.8rem"
                            >
                              Se realizará la comprobación sumando los {{ numberOfIncrementsPerShower }} incrementos anteriores
                            </p>
                          </div>
                        </b-form-group>
                        <b-form-group
                          label="Máximo consumo (L/s)"
                          label-size="sm"
                          label-for="max-consumption"
                          v-if="selectedTypeAlias == 'Contador Hidrojet 80H-20V'"
                        >
                          <b-form-input
                            id="max-consumption"
                            size="sm"
                            placeholder="..."
                            v-model="currentSensor.thresholds.maxConsumption"
                            :value="currentSensor.thresholds.maxConsumption"
                          />
                        </b-form-group>
                        <b-form-group
                          label="Máximo consumo acumulado (L/s)"
                          label-size="sm"
                          label-for="max-accumulated-consumption"
                          v-if="selectedTypeAlias == 'Contador Hidrojet 80H-20V'"
                        >
                          <b-form-input
                            id="max-accumulated-consumption"
                            size="sm"
                            placeholder="..."
                            v-model="currentSensor.thresholds.maxAcummulatedConsumption"
                            :value="currentSensor.thresholds.maxAcummulatedConsumption"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-form>
          <!-- END FORMULARIO DE ADICION -->
        </div>
        <!-- END V if submitted-->

        <div v-else>
          <basic-circle-loader />
        </div>
      </div>
    </b-card>
  </div>
</template>


<script>
import BasicCircleLoader from "@/components/common/BasicCircleLoader";
import SensorService from "@/services/SensorService";
import DeviceService from "@/services/DeviceService";
import UserService from "@/services/UserService";
import Vue from 'vue';


export default {
  name: "edit-sensor",
  components: {
    "basic-circle-loader": BasicCircleLoader,
  },
  data() {
    return {
      //selectedType es necesario aquí hasta que añadamos el tipo al modelo de datos
      //También habría que actualizar el v-model acorde para que coja el campo del modelo
      currentSensor: [],
      deviceAliasList: [],
      selectedDeviceAlias: "",
      typeAliasList: [],
      selectedTypeAlias: "",
      dataFieldCount: 0,
      selectedType: null,
      dataFields: null,
      submitted: false,
      disabledInput: false,
      idtemporal: null,
      numberOfIncrementsPerShower: 20
    };
  },
  watch: {
    selectedType: function () {
      let fields = eval("(" + this.selectedType.columns + ")");
      fields = fields.slice(2, fields.length);
      //console.log(this.selectedTypeAlias);
      this.dataFields = fields;
    },
  },
  methods: {
    retrieveDevice() {
      DeviceService.getAll()
        .then((response) => {
          response.data.forEach((element) => {
            this.deviceAliasList.push(element.alias);
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },

    retrieveType() {
      SensorService.getAllTypes()
        .then((response) => {
          var jsonArray = response.data;
          for (var i = 0; i < jsonArray.length; i++) {
            var obj = jsonArray[i];
            this.typeAliasList.push(obj.alias);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    getSensor(idsensor) {
      //Delay de carga
      this.loadDelay();
      //Get device data
      SensorService.get(idsensor)
        .then((response) => {
          this.currentSensor = response.data;
          this.selectedDeviceAlias = this.currentSensor.device
            ? this.currentSensor.device.alias
            : "null";
          this.selectedTypeAlias = this.currentSensor.type
            ? this.currentSensor.type.alias
            : "null";
          this.dataFieldCount = this.currentSensor.type
            ? (this.currentSensor.type.columns.match(/{/g) || []).length - 2
            : 0;
          this.fillType();
          this.idtemporal = idsensor;
          if(this.selectedTypeAlias == 'Pluviometro WS2080' || this.selectedTypeAlias == 'Contador Hidrojet 80H-20V'){
            this.currentSensor.thresholds = this.currentSensor.thresholds && this.currentSensor.thresholds != {}
            ? this.currentSensor.thresholds 
            : this.selectedTypeAlias == 'Pluviometro WS2080'? {maxIncrement: null, maxShowerAccumulation: null} : {maxConsumption: null, maxAcummulatedConsumption: null};
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    cleanMeasures() {
      SensorService.deleteMeasures(this.idtemporal)
        .then((response) => {
          this.$notify({
            group: "notificateDiv",
            type: "success",
            title: response.data.message
              ? response.data.message
              : "Medidas eliminadas correctamente",
            text: response.data.message
              ? "Se ha(n) eliminado " + response.data.count + " medida(s)"
              : "",
            duration: 3000,
            speed: 1000,
          });
          this.loadMeasures();
        })
        .catch((e) => {
          this.$notify({
            group: "notificateDiv",
            type: "error",
            title: "Error eliminando medidas",
            text: "",
            duration: 3000,
            speed: 1000,
          });

          console.log(e);
        });
    },

    loadMeasures() {
      if (this.idtemporal) {
        this.$refs.measuresComp.retrieveDataFromSensor(this.idtemporal);
      }
    },

    updateSensor(e) {
      //Prevent submit
      e.preventDefault();
      //Disable buttons before re-enabled
      this.disabledInput = true;
      //Update the sensor
      //this.fillDeviceData(this.fillTypeData(this.actualUpdate));
      this.fillDeviceData();
    },

    fillDeviceData() {
      if (this.selectedDeviceAlias && this.selectedDeviceAlias != "null") {
        DeviceService.findByAlias(this.selectedDeviceAlias)
          .then((response) => {
            this.currentSensor.device = response.data;
            this.fillTypeData(this.actualUpdate);
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        this.currentSensor.device = null;
        this.fillTypeData(this.actualUpdate);
      }
    },

    fillTypeData(callback) {
      if (this.selectedTypeAlias && this.selectedTypeAlias != "null") {
        SensorService.findTypeByAlias(this.selectedTypeAlias)
          .then((response) => {
            this.currentSensor.type = response.data;
            if(this.selectedTypeAlias == 'Pluviometro WS2080' || this.selectedTypeAlias == 'Contador Hidrojet 80H-20V'){
              this.currentSensor.thresholds = JSON.stringify(this.currentSensor.thresholds);
            }
            callback();
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        this.currentSensor.type = null;
        callback();
      }
    },

    fillType() {
      if (this.selectedTypeAlias && this.selectedTypeAlias != "null") {
        SensorService.findTypeByAlias(this.selectedTypeAlias)
          .then((response) => {
            this.selectedType = response.data;
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        this.selectedType = "null";
      }
    },

    actualUpdate() {
      if (!this.selectedType.shmCapable) {
        this.currentSensor.isShm = false;
      }
      /* if(this.selectedTypeAlias == 'Pluviometro WS2080'){
        SensorService.updateThresholdBySensorId(this.currentSensor); 
      } */
      SensorService.update(this.currentSensor)
        .then((response) => {
          this.getSensor(this.currentSensor._id);

          //Mensaje de actualización
          this.$notify({
            group: "notificateDiv",
            type: "success",
            title: response.data.message
              ? response.data.message
              : "Sensor modificado correctamente",
            text: response.data.message
              ? ""
              : "Se ha modificado el sensor seleccionado",
            duration: 3000,
            speed: 1000,
          });
          //delay antes de rehabilitarlos
          setTimeout(() => {
            //Avisamos al parent de que cambie componente
            this.disabledInput = false;
          }, 500);
          //Refresh table list (parent signal)
          this.$emit("updated");
        })
        .catch((e) => {
          console.log(e);
          //Mensaje de actualización
          this.$notify({
            group: "notificateDiv",
            type: "pepito",
            title: "Error al guardar los cambios",
            text: "No se han podido almacenar los cambios solicitados",
            duration: 3000,
            speed: 1000,
          });
        });
      //Rehabilitiamso lso botones de nuevo
      this.disabledInput = false;
    },

    loadDelay() {
      //Cargamos el div oculto
      this.submitted = true;
      //Timeout para cambiar de pagina
      setTimeout(() => {
        //Cambiamos de div
        this.submitted = false;
      }, 500);
    },

    exitForm() {
      //Delay de carga
      this.loadDelay();
      setTimeout(() => {
        //Avisamos al parent de que cambie componente
        this.$emit("exit");
      }, 500);
    },

    getImgUrl(image) {
      return require("@/assets/images/" + image);
    },

    isUserAdmin() {
      return UserService.isUserAdmin();
    },
  },
  mounted() {
    //Cargamos la lista
    this.retrieveDevice();
    this.retrieveType();

    //Para que no de el coñazo
    Vue.config.silent = true;
  },
};
</script>

<style scoped>
.groupBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 30px;
}

.innergroupBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 20px;
}

.innergroupBoxAlt {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 5px;
  margin-bottom: 10px;
}

.titulo1 {
  font-size: 0.95rem;
  color: #606266;
  text-align: center;
  font-weight: 400;
}
</style>
